let idByCurrentTime = (new Date).getTime();

export const changeIdofBlock = (block) => {
    changeItemId ( block )
    block.columns.forEach( ( column ) => {
      changeItemId ( column )
      column.addons.forEach( (addon) => {
        if ( addon.type == 'inner_row' ) {
          changeIdofBlock( addon )
        } else {
          changeItemId ( addon )
        }

        return addon;
      })
      return column;
    });

  return block;
}

const changeItemId = (item) =>{
  item.id = idByCurrentTime++
  return item
}



// WEBPACK FOOTER //
// ./src/helpers/commonHelper.js